export default __webpack_public_path__ + "static/g3-dark-logo-61e5af2e3af50322399a2c2c419e915f.svg";